import React from 'react';
import { useTranslation } from 'react-i18next';
import { Segment, Dimmer, Loader } from 'semantic-ui-react';

const Loading = ({ prompt: name = 'page' }) => {
  const { t } = useTranslation();
  return (
    <Segment style={{ height: 100 }}>
      <Dimmer active inverted>
        <Loader indeterminate>
          {t('messages.loading.loading', { name })}
        </Loader>
      </Dimmer>
    </Segment>
  );
};

export default Loading;
